<template>
  <a-menu
    :class="{ 'side-menu': true, 'admin-side-menu': isAdmin }"
    v-model:openKeys="openKeys"
    v-model:selectedKeys="selectedKeys"
    mode="vertical"
    forceSubMenuRender
    @click="onClickMenuItem"
  >
    <template v-for="menuItem in state.menus" :key="menuItem.path">
      <a-menu-item v-if="!menuItem.children" :key="menuItem.path">
        <template #icon>
          <component :is="menuItem.icon" />
        </template>
        <span>{{ $t(menuItem.title ?? '') }}</span>
      </a-menu-item>
      <a-sub-menu
        v-else
        :popupClassName="isAdmin ? 'side-submenu' : ''"
        :key="menuItem.path"
        @click="onClickSubMenu(menuItem)"
      >
        <template #icon>
          <component :is="menuItem.icon" />
        </template>
        <template #title>{{ $t(menuItem.title ?? '') }}</template>
        <template v-for="subMenuItem in menuItem.children" :key="subMenuItem.path">
          <a-menu-item v-if="!subMenuItem.children" :key="subMenuItem.path">
            <span>{{ $t(subMenuItem.title ?? '') }}</span>
          </a-menu-item>
          <a-sub-menu
            v-else-if="subMenuItem.title != 'account_master'"
            :key="subMenuItem.path"
            @click.stop="onClickSecondSubMenu(subMenuItem)"
          >
            <template #title>{{ subMenuItem.title }}</template>
            <a-menu-item v-for="child in subMenuItem.children" :key="child.path">
              {{ child.title }}
            </a-menu-item>
          </a-sub-menu>
          <a-menu-item v-else :key="subMenuItem.path">
            <span>{{ $t(subMenuItem.title ?? '') }}</span>
          </a-menu-item>
        </template>
      </a-sub-menu>
      <a-divider
        :dashed="true"
        :class="!props.isRight ? 'menu-divider !ml-3' : 'menu-divider-black !ml-2'"
        v-if="
          (menuItem.path == '/invoice-management' && isDischarger) ||
          (menuItem.path == '/license-management' && !isDischarger) ||
          (menuItem.path == '/notice' && isAdmin)
        "
      />
    </template>
  </a-menu>
</template>

<script setup lang="ts">
import { computed, reactive, onMounted, watch, ref } from 'vue';
// import { HomeOutlined, UserOutlined, BarsOutlined } from '@ant-design/icons-vue';
import { useRoute, useRouter } from 'vue-router';
import type { RouteMeta, RouteRecordRaw } from 'vue-router';
import { useLayoutStore } from '@/stores';
import { useAuthStore } from '@/stores';
import { storeToRefs } from 'pinia';

const authStore = useAuthStore();
const { isAdmin, isDischarger, isTransporter } = storeToRefs(authStore);

const props = defineProps<{
  isRight: boolean;
}>();

type MenuItem = RouteMeta & { path: string } & { children?: MenuItem[] };
interface State {
  menus: MenuItem[];
}

const state = reactive<State>({
  menus: []
});

const selectedKeys = ref<string[]>(['/']);
const openKeys = ref<string[]>([]);

const currentRoute = useRoute();
selectedKeys.value = currentRoute.matched.map((val) => val.path);

const router = useRouter();
const layoutStore = useLayoutStore();

// 根据路由转换菜单（二三级）
const updateMenuOnRouter = () => {
  const routers = router.getRoutes().filter((val) => val.meta.root);
  state.menus = routers.reduce((total: MenuItem[], cur: RouteRecordRaw) => {
    const parent: MenuItem = { path: cur.path, ...cur.meta };
    if (parent.isHide) return total;
    if (cur.children) {
      const items = cur.children.filter((val) => val.meta && !val.meta.isHide);
      const childs = items.map((item: RouteRecordRaw) => {
        const current: MenuItem = { path: item.path, ...item.meta };
        if (item.children)
          current.children = item.children.map((val) => ({ path: val.path, ...val.meta }));
        return current;
      });
      if (childs.length > 0) {
        parent.children = childs;
      }
    }
    return [...total, parent];
  }, []);
};

const onClickMenuItem = ({ key, keyPath }: { key: string; keyPath: string[] }) => {
  router.push({ path: key });
};

const onClickSubMenu = ({ path }: MenuItem) => {};

const onClickSecondSubMenu = ({ path }: MenuItem) => {};

watch(
  () => currentRoute.fullPath,
  () => {
    selectedKeys.value = currentRoute.matched.map((val) => val.path);
    openKeys.value = [];
  }
);

onMounted(() => {
  updateMenuOnRouter();
});
</script>

<style lang="scss">
.menu-divider.ant-divider {
  border-block-start: 1px solid rgba(255, 255, 255, 0.65);
  border-style: dashed;
}

.menu-divider-black.ant-divider {
  border-block-start: 1px solid rgba(0, 0, 0, 0.65);
  border-style: dashed;
}

.menu-divider-black.ant-divider-horizontal {
  margin: 8px 0;
}

.side-menu.ant-menu-light .ant-menu-item-selected {
  background-color: white;
}

.side-menu.ant-menu-light .ant-menu-submenu-selected > .ant-menu-submenu-title {
  color: white;
}

.side-menu.ant-menu-light .ant-menu-item-active:not(.ant-menu-item-selected) {
  color: white !important;
}

.side-menu.ant-menu-light
  .ant-menu-submenu-active:not(.ant-menu-submenu-selected)
  > .ant-menu-submenu-title {
  color: white !important;
}

.side-submenu .ant-menu.ant-menu-sub.ant-menu-vertical {
  background-color: #f46666;
  color: white;
}

.admin-side-menu.ant-menu-light .ant-menu-item-selected {
  background-color: white;
  color: #f46666;
}

.admin-side-menu .ant-menu-submenu.ant-menu-submenu-vertical.ant-menu-submenu-selected,
.admin-side-menu .ant-dropdown-menu-submenu-selected {
  background-color: white;
}

.ant-menu-submenu-selected > .ant-menu-submenu-title {
  color: #f46666 !important;
}

.admin-side-menu .ant-dropdown-menu-submenu-selected > .ant-dropdown-menu-submenu-title {
  color: #f46666 !important;
}

.side-submenu.ant-menu-light .ant-menu-item-selected,
.side-submenu.ant-dropdown-menu-submenu .ant-dropdown-menu .ant-dropdown-menu-item-selected {
  color: #f46666;
}

.side-submenu.ant-menu-light .ant-menu-item-active:not(.ant-menu-item-selected) {
  color: white !important;
}

.side-submenu.ant-menu-submenu > .ant-menu {
  border-radius: 0;
}

.ant-dropdown .ant-dropdown-menu.side-menu {
  border-radius: 0;
}

.side-submenu.ant-dropdown-menu-submenu .ant-dropdown-menu {
  border-radius: 0;
}

.menu-divider {
  min-width: 92% !important;
  width: 92% !important;
}

.menu-divider-black {
  min-width: 92% !important;
  width: 92% !important;
}
</style>
